import React, { ReactNode, useEffect } from 'react';
import { Alert, AlertColor, Box } from '@mui/material';

interface InfoAlertProps {
    message: ReactNode | string;
    severity?: AlertColor;
    onClose: () => void;
    autoCloseDuration?: number;
    style?: React.CSSProperties;
}

const InfoAlert: React.FC<InfoAlertProps> = ({ message, onClose, autoCloseDuration = 10000, severity = 'info', style }) => {
    useEffect(() => {
        if (autoCloseDuration) {
            const timer = setTimeout(onClose, autoCloseDuration);
            return () => clearTimeout(timer);
        }
    }, [onClose, autoCloseDuration]);

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 72,
                left: 0,
                right: 0,
                zIndex: (theme) => theme.zIndex.snackbar,
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'none',
            }}
            style={style}
        >
            <Alert
                severity={severity}
                onClose={onClose}
                sx={{
                    pointerEvents: 'auto',
                    maxWidth: 'calc(100vw - 32px)',
                }}
            >
                {message}
            </Alert>
        </Box>
    );
};

export default InfoAlert;
